import { useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'

import BtnGrid from '@App/components/BtnGrid/BtnGrid'
import IconBtnHor from '@App/components/IconBtnHor/IconBtnHor'

import './source-toggles.css'

function SourceToggles({ sources, setSourceActiveNames, sourcesActiveNames }) {
  const dispatch = useDispatch()

  const toggleSource = useCallback((sourceNames) => {
    dispatch(setSourceActiveNames(sourceNames))
  }, [dispatch, setSourceActiveNames])

  useEffect(() => {
    if (sourcesActiveNames === undefined && sources && sources.length > 0) {
      const allSourceNames = sources.map(source => source.id)
      toggleSource(allSourceNames)
    }
  }, [toggleSource, sourcesActiveNames, sources])

  if (Array.isArray(sources) && sources.length === 0) {
    return <p className="source-toggles__no-data-message">No data to show for date</p>
  }

  if (!sources || !sourcesActiveNames) return null

  return (
    <BtnGrid>
      {sources.map((source) => {
        const { id, name, icon, fullWidthIcon } = source
        const active = sourcesActiveNames.includes(id)

        return (
          <IconBtnHor
            key={id}
            iconProps={{ icon: `/img/icons/sources/${icon}`, size: '24px' }}
            inactive={!active}
            noText={fullWidthIcon}
            onClick={() => {
              const newActiveSourceNames = active ? sourcesActiveNames.filter(curr => curr !== id) : [...sourcesActiveNames, id]
              toggleSource(newActiveSourceNames)
            }}
          >
            {name || null}
          </IconBtnHor>
        )
      })}
    </BtnGrid>
  )
}

export default SourceToggles
